import { Component, Input } from '@angular/core';
import { LoStatus } from 'lo-design-system';

@Component({
	standalone: true,
	selector: 'meta-perm-row',
	imports: [LoStatus],
	template: `
		<div class="perm-row">
			<div class="info">
				<span class="code lo-type-text-sm-semibold">{{ code }}</span>
				<span class="desc lo-type-text-xs">{{ description }}</span>
			</div>
			<lo-status [tone]="granted && !disabled ? 'success' : 'neutral'">
				{{ granted && !disabled ? 'Granted' : 'Not granted' }}
			</lo-status>
		</div>
	`,
	styles: [
		`
			:host {
				display: block;

				.perm-row {
					display: flex;
					align-items: center;
					gap: var(--lo-space-gap-md);
					padding: var(--lo-space-gap-md) 0;
					border-top: 1px solid var(--lo-color-border-default);

					.info {
						display: flex;
						flex: 1;
						flex-direction: column;
						min-width: 0;

						.desc {
							color: var(--lo-color-text-secondary);
						}
					}
				}
			}

			:host(:first-of-type) .perm-row {
				border-top: none;
			}
		`
	]
})
export class MetaPermRowComponent {
	@Input({ required: true }) code = '';
	@Input() description = '';
	@Input() granted = false;
	@Input() disabled = false;
}
